/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAccountUsageRequest
 */
export interface UpdateAccountUsageRequest {
    /**
     * Anzahl der analysierten Steine
     * @type {number}
     * @memberof UpdateAccountUsageRequest
     */
    bricksAnalyzed: number;
    /**
     * ID des analysierten Dokuments
     * @type {string}
     * @memberof UpdateAccountUsageRequest
     */
    documentId: string;
}

/**
 * Check if a given object implements the UpdateAccountUsageRequest interface.
 */
export function instanceOfUpdateAccountUsageRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bricksAnalyzed" in value;
    isInstance = isInstance && "documentId" in value;

    return isInstance;
}

export function UpdateAccountUsageRequestFromJSON(json: any): UpdateAccountUsageRequest {
    return UpdateAccountUsageRequestFromJSONTyped(json, false);
}

export function UpdateAccountUsageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAccountUsageRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bricksAnalyzed': json['bricksAnalyzed'],
        'documentId': json['documentId'],
    };
}

export function UpdateAccountUsageRequestToJSON(value?: UpdateAccountUsageRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bricksAnalyzed': value.bricksAnalyzed,
        'documentId': value.documentId,
    };
}

